import searchRecommendApi from './api/searchRecommendApi';

/* ACTIONS */
export const KEYWORD_MAPPING_LIST = 'KEYWORD_MAPPING/LIST';
export const KEYWORD_MAPPING_ADD = 'KEYWORD_MAPPING/ADD';
export const KEYWORD_MAPPING_UPDATE = 'KEYWORD_MAPPING/UPDATE';
export const KEYWORD_MAPPING_DELETE = 'KEYWORD_MAPPING/DELETE';

const initialState = {
    keywordMappings: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case KEYWORD_MAPPING_LIST:
            return {
                ...state,
                keywordMappings: action.payload,
            };
        case KEYWORD_MAPPING_UPDATE:
            return {
                ...state,
                keywordMappings: state.keywordMappings.map(mapping => 
                    (mapping.id === action.payload.id || mapping._id === action.payload._id) 
                        ? action.payload 
                        : mapping
                ),
            };
        case KEYWORD_MAPPING_DELETE:
            return {
                ...state,
                keywordMappings: state.keywordMappings.filter(mapping => 
                    mapping.id !== action.payload.id && mapping._id !== action.payload.id
                ),
            };
        default:
            return state;
    }
};

export const getKeywordMappings = ({env}) => {
    return dispatch => {
        return searchRecommendApi.get(`/keyword?env=${env}`).then(data => {
            dispatch({
                type: KEYWORD_MAPPING_LIST,
                payload: data
            });
            return data;
        }).catch(error => {
            throw (error);
        });
    };
};

export const addKeywordMapping = ({ keyword, contentId, active, env }) => {
    return dispatch => {
        const now = new Date().toISOString();
        return searchRecommendApi.post(`/keyword?env=${env}`, {
            keyword,
            contentId,
            active,
        }).then(data => {
            return data;
        }).catch(error => {
            throw (error);
        });
    };
};

export const updateKeywordMapping = ({ id, keyword, contentId, active, env }) => {
    return dispatch => {
        const now = new Date().toISOString();
        return searchRecommendApi.patch(`/keyword/${id}?env=${env}`, {
            keyword,
            contentId,
            active,
            updated_at: now
        }).then(data => {
            dispatch({
                type: KEYWORD_MAPPING_UPDATE,
                payload: data
            });
            return data;
        }).catch(error => {
            throw (error);
        });
    };
};

export const deleteKeywordMapping = ({ id, env }) => {
    return dispatch => {
        return searchRecommendApi.delete(`/keyword/${id}?env=${env}`).then(data => {
            dispatch({
                type: KEYWORD_MAPPING_DELETE,
                payload: { id }
            });
            return data;
        }).catch(error => {
            throw (error);
        });
    };
};
